import React from "react";

/**
 * A helper method to label motifs in sequence.
 * @param sequence {string} The string before highlighting motifs
 * @param sites {object} the sites of the motifs. {"starting position": "end position"}
 * @param textBackgroundColor {string} the bootstrap class name of the highlighted text. default value = "bg-success".
 * @returns A string representative of the sequence with all the motifs sites highlighted.
 */
const labelMotifsInSequence = (sequence, sites, textBackgroundColor="bg-success") => {
  const combinedSites = {} // these sites needs to be combined {3: 25, 4: 26} to {3: 26} because they are connected
  const startingPositions = []
  for (const startingPosition in sites) {
    startingPositions.push(startingPosition);
  }
  startingPositions.sort();
  
  let start = 0; 
  let end = 0;
  while (startingPositions.length !== 0 ) {
    let currentStartingPosition =  startingPositions.shift();
    let currentEndPosition = sites[currentStartingPosition];
    if (currentStartingPosition >= end) { // {3:4, 7:9} or {3:4}
      start = currentStartingPosition;
      end = currentEndPosition;
      combinedSites[start] = end;
    }
    if (currentStartingPosition < end) { // {3:7, 4: 8} or {3:8, 4:7}
      if (currentEndPosition > end) { // {3:7, 4: 8} => {3: 8}
        end = currentEndPosition;
        combinedSites[start] = end;
      } else { //{3:8, 4:7}
        // do nothing, so 4:7 will not be stored in combined sties
      }
    }
  }

  let labeledSequence = []; // 12345678 {1:2} string.substring(1-1, 2)
  let unlabeledStartPosition = 0;
  for (let key in combinedSites) {
    labeledSequence.push (<span key={key + "unlabeled"}>{sequence.substring(unlabeledStartPosition, key)}</span>); 
    labeledSequence.push (<span key={key + "labeled"} className={textBackgroundColor}>{sequence.substring(key, combinedSites[key]+1)}</span>)
    unlabeledStartPosition = combinedSites[key]+1;
  }
  labeledSequence.push(<span key="end-seq">{sequence.substring(unlabeledStartPosition)}</span>);
  return labeledSequence;
}

export default labelMotifsInSequence;
